module.exports = new __parcel__URL__("Knifehit.aadc7804.png").toString();